import matchesProperty from "lodash-es/matchesProperty";
import { OrganizationsService } from "../../services";
import ActiveOne from "./active-organization";
import axiosClient from "../../services/axiosClient.js";

function resetState() {
  return {
    active_org_id: undefined,
    organizations: [],
  };
}

export default {
  namespaced: true,

  state: resetState(),

  getters: {
    getAll(state) {
      return state.organizations;
    },

    getActive(state) {
      return state.organizations.find(matchesProperty("id", state.active_org_id));
    },
  },

  mutations: {
    SET_ORGANIZATIONS(state, value) {
      // state.organizations = value;

      let mergedOrganizations = state.organizations.concat(value); // вновь полученные в конец

      // убираем повторы
      mergedOrganizations = mergedOrganizations.filter(
        (org1, orgIndex) => orgIndex === mergedOrganizations.findIndex((org2) => org1.id === org2.id)
      );

      state.organizations = mergedOrganizations;
    },

    SET_ACTIVE_ID(state, id) {
      state.active_org_id = id;
    },

    RESET_STATE(state) {
      Object.assign(state, resetState());
    },
  },

  actions: {
    init({ commit }, organizations) {
      commit("SET_ORGANIZATIONS", organizations);
    },

    async findOrganizations({ commit }, { amount, findstr, lastId }) {
      const organizations = await OrganizationsService.fetchOrganizations({ amount, findstr, lastId });

      commit("SET_ORGANIZATIONS", organizations);

      return organizations;
    },

    selectActive({ commit, dispatch }, { userId, orgId }) {
      commit("SET_ACTIVE_ID", orgId);
      dispatch("Thread/resetStateThreads", {}, { root: true });
      dispatch("setZoneHeader"); // посылаем зону. откуда пришла организация, в заголовках

      localStorage.setItem(`cab-org-id:${userId}`, orgId);
    },

    // HACK: при изменении orgId - сразу посылаем новую зону в заголовках
    // Вариант изменения зоны с помощью отдельного запроса - не работает (зона не сохраняется в сессии)
    setZoneHeader({ getters }) {
      if (getters.getActive?.outsourcer_zone) {
        axiosClient.defaults.headers.common["x-ufa-zone"] = getters.getActive.outsourcer_zone;
      }
    },

    resetState({ commit, dispatch }) {
      dispatch("ActiveOne/resetState");

      commit("SET_ORGANIZATIONS", []);

      commit("RESET_STATE");
    },
  },

  modules: {
    ActiveOne,
  },
};
